module.exports = __webpack_public_path__ + "img/skills-fireclaws-dru-1.51efabb1.png";